<template>
  <div>
    <div v-if="profilesUser.length > 0" class="col-xl-12 col-lg-12 col-md-12 mb-4">
      <div class="card card-style">
        <form action @submit.prevent id data-vs-form="form-profile-user">
          <div class="card-body">
            <div>
              <div class="title_edit_container">
                <div>
                  <div class="subtitle_useram">
                    {{
                      $t('message.userActive.subtitle_employee_configuration_profiles')
                    }}
                  </div>
                  <div class="aclaration_title mt-1">
                    {{ $t('message.userActive.profiles_aclaration') }}
                  </div>
                </div>
                <transition name="fade" mode="out-in">
                  <div v-if="isEditingProfile" class="m-portlet__head-caption">
                    <button data-vs-button="profile-edit" @click.prevent="cancelEditInformation('isEditingProfile')"
                      class="btn btn-secondary mr-4">
                      {{ $t('message.ob_submit_swal_reject') }}
                    </button>
                    <button data-vs-button="save-profile-edit" v-if="!loadingProfiles" type="submit"
                      @click.prevent="saveUserProfiles(false)" class="btn btn-primary">
                      {{ $t('message.ei_personal_info_save_changes') }}
                    </button>
                    <button data-vs-button="loading-profile-edit" v-if="loadingProfiles" type="submit"
                      class="btn btn-primary">
                      <div class="m-loader m-loader--light"></div>
                    </button>
                  </div>
                </transition>
              </div>
              <hr />
              <div class="w-full m-6 px-2 mx-auto" v-if="hasCertSign">
                <zt-alert color="warning" :closeIcon="false" :text="$t('message.userActive.alertHasCertSign')">
                  <div slot="icon" class="text-center text-2xl">
                    <zt-icon name="exclamation-triangle" />
                  </div>
                </zt-alert>
              </div>
              <div class="form-container row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex m-2 align-items-baseline">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                    <label class="m-checkbox m-checkbox--bold m-checkbox--state-success">
                      <input data-vs-checkbox="profile-employee-state" class="profiles-text"
                        :value="form.profile.employeeState" :disabled="employeeState == 3 || hasCertSign"
                        @click="editInformation('isEditingProfile')" v-model="form.profile.employeeState"
                        @change="addEmployeeProfile" id="form.profile.employeeState" type="checkbox" />
                      {{ $t('message.userActive.profile_employee_title') }}
                      <span></span>
                    </label>
                  </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-2 mb-4 align-items-baseline">
                  <div class="aclaration_title">
                    {{ $t('message.userActive.select_profile') }}
                  </div>
                  <div class="pl-0 col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-3 d-flex align-items-center">
                    <div class="pl-3 col-xl-10 col-lg-10 col-md-10 col-sm-10 d-flex align-items-center edit-component">
                      <multiselect data-vs-select="profile-type" @input="addRRHHProfile(form.profile.managementState)"
                        v-model="form.profile.managementState" :disabled="employeeState == 3 || hasCertSign"
                        :options="profilesCompany" :searchable="true" :close-on-select="true" :show-labels="false"
                        label="nombre" :placeholder="$t('message.userActive.profile_management_title')">
                        <template slot="noResult">
                          <span class="multiselect__single">{{ $t('message.userActive.error_locacion_not_found') }}
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <span v-if="hasProfileCertSign(props.option.nombre)" :style="{ 'pointer-events': 'none' }">
                            {{ props.option.nombre }}
                          </span>
                          <span v-else>{{ props.option.nombre }}</span>
                        </template>
                      </multiselect>
                    </div>
                    <div data-vs-button="clear-profile" v-if="
                      form.profile.managementState != '' &&
                      form.profile.managementState != null &&
                      employeeState != 3 &&
                      !hasCertSign
                    " @click="editInformation('isEditingProfile')"
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 d-flex justify-content-start align-items-end pl-2">
                      <div @click="clearRRHHProfile" class="icon-NotOk"></div>
                      <div @click="clearRRHHProfile" class="button-add ml-1 text-nowrap">
                        {{ $t('message.userActive.remove_profiles') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <transition name="slide" mode="out-in">
                <div v-if="
                  form.profile.managementState != null &&
                  form.profile.managementState != ''
                " class="form-container row mb-4">
                  <div class="subtitle-container col-12 d-flex">
                    <div>
                      <div class="subtitle_useram">
                        {{ $t('message.userActive.title_employee_filter') }}
                      </div>
                      <div class="aclaration_title mt-1">
                        {{ $t('message.userActive.filter_aclaration') }}
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex mt-2 mb-3">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 input-group edit-component">
                      <multiselect data-vs-select="user-sector" name="perfilSector" id="perfilSector"
                        v-model="form.profile.sectionState" :disabled="employeeState == 3 || hasCertSign"
                        :options="sectionCompany" :searchable="true" :close-on-select="true" :show-labels="false"
                        :placeholder="$t('message.search_text_4')">
                        <template slot="noResult">
                          <span class="multiselect__single">{{
                            $t('message.userActive.error_locacion_not_found')
                            }}</span>
                        </template>
                        <template slot="maxElements">
                          <span class="multiselect__single">{{
                            $t('message.userActive.max_elements')
                            }}</span>
                        </template>
                      </multiselect>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 input-group edit-component">
                      <multiselect data-vs-select="user-location" name="perfilLocacion" id="perfilLocacion"
                        v-model="form.profile.locationState" :disabled="employeeState == 3 || hasCertSign"
                        :options="locationCompany" :searchable="true" :close-on-select="true" :show-labels="false"
                        :placeholder="$t('message.search_text_5')">
                        <template slot="noResult">
                          <span class="multiselect__single">{{
                            $t('message.userActive.error_sector_not_found')
                            }}</span>
                        </template>
                        <template slot="maxElements">
                          <span class="multiselect__single">{{
                            $t('message.userActive.max_elements')
                            }}</span>
                        </template>
                      </multiselect>
                    </div>
                    <div v-if="employeeState !== 3 && !hasCertSign"
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 d-flex justify-content-start align-items-center">
                      <div data-vs-button="add-new-location" :disabled="!isEditingProfile" @click="addSectionLocation"
                        class="la la-plus-circle add-style"></div>
                      <div data-vs-button="add-new-location-label" class="button-add ml-1" @click="addSectionLocation">
                        {{ $t('message.userActive.add_employee_filter') }}
                      </div>
                    </div>
                  </div>
                  <div v-if="sectionLocationEmployee.length != 0 && !hasCertSign" style="display: contents">
                    <div v-show="sectionLocationEmployee.length != 0" class="noStateAsigment ml-4 mt-2"
                      v-for="item in sectionLocationEmployee">
                      <button data-vs-button="delete-new-section" type="button" class="btn btn-outline-brand btn-pill"
                        :disabled="employeeState == 3" @click="deleteSectionLocation(item[0], item[1])">
                        {{ item[1] }}
                        <div v-if="item[0] != null && item[1] != null">&nbsp | &nbsp</div>
                        {{ item[0] }}
                        <button :disabled="!isEditingProfile" class="deleteButton d-flex">
                          <i class="la la-remove ml-2"></i>
                        </button>
                      </button>
                    </div>
                  </div>
                  <div v-if="sectionLocationEmployee.length === 0 && !hasCertSign">
                    <div class="noStateAsigment" v-show="!form.profile.managementState.nombre.includes('X_SECTOR')">
                      <p v-if="
                        !form.profile.managementState.nombre.includes('RRHH') &&
                        $store.getters.getUserList.sector.length != 0 &&
                        $store.getters.getUserList.locacion.length != 0
                      " class="aclaration_title empty mt-3 col-12">
                        {{ $t('message.userActive.managerProfile') }}
                      </p>
                      <p v-else class="aclaration_title empty mt-3 col-12">
                        {{ $t('message.userActive.noFilterSLrrhh') }}
                      </p>
                    </div>
                    <div class="noStateAsigment" v-show="form.profile.managementState.nombre.includes('X_SECTOR')">
                      <p class="aclaration_title empty mt-3 col-12" v-if="
                        $store.getters.getUserList.sector.length != 0 &&
                        $store.getters.getUserList.locacion.length != 0
                      ">
                        {{
                          $t('message.userActive.noFilterSLxSector') +
                          ' (' +
                          $store.getters.getUserList.sector +
                          ' | ' +
                          $store.getters.getUserList.locacion +
                          ')'
                        }}
                      </p>
                      <p class="aclaration_title empty mt-3 col-12" v-else>
                        {{ $t('message.userActive.noFilterSLrrhh') }}
                      </p>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="row mb-4">
              <transition v-if="
                form.profile.managementState != null &&
                form.profile.managementState != ''
              " name="slide" mode="out-in">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 ml-1">
                  <div class="subtitle_useram">
                    {{ $t('message.userActive.foldersFilters') }}
                  </div>
                  <div class="aclaration_title">
                    {{ $t('message.userActive.folders_aclaration') }}
                  </div>
                  <div class="row form-container">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex align-items-center mb-2">
                      <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10">
                        <div class="input-group edit-component">
                          <multiselect v-if="folderMultiselect" v-model="folderSelected" :options="companyFolders"
                            :disabled="employeeState == 3 || hasCertSign" :searchable="true" :close-on-select="true"
                            :show-labels="false" label="carpeta_nombre"
                            :placeholder="$t('message.userActive.select_folders')">
                            <template slot="noResult">
                              <span class="multiselect__single">{{
                                $t('message.search_folder_placeholder')
                                }}</span>
                            </template>
                            <template slot="noOptions">
                              <span class="multiselect__single">{{
                                $t('message.search_folder_placeholder')
                                }}</span>
                            </template>
                          </multiselect>
                        </div>
                      </div>
                      <div v-if="
                        companyFolders.length > 0 && employeeState !== 3 && !hasCertSign
                      " @click="addFolder()"
                        class="col-xl-2 col-lg-2 col-md-2 col-sm-2 d-flex justify-content-start align-items-center">
                        <div class="la la-plus-circle add-style"></div>
                        <div class="button-add ml-1">
                          {{ $t('message.userActive.add_employee_filter') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <transition v-if="
                form.profile.managementState != null &&
                form.profile.managementState != ''
              " name="slide" mode="out-in">
                <div v-if="foldersUser.length == 0 && employeeState != 3 && !hasCertSign">
                  <div class="noStateAsigment" v-show="foldersUser.length == 0 && employeeState != 3">
                    <p class="aclaration_title empty my-3 col-12">
                      {{ $t('message.userActive.noFilterFolders') }}
                    </p>
                  </div>
                </div>
                <div v-if="foldersUser.length != 0 && employeeState != 3 && !hasCertSign" style="display: contents">
                  <div v-show="foldersUser.length != 0 && employeeState != 3" class="noStateAsigment ml-4 my-2"
                    v-for="(folder, index) in foldersUser" @click="removeItem(index)" :key="folder.carpeta_nombre">
                    <button type="button" class="btn btn-outline-brand btn-pill">
                      {{ folder.carpeta_nombre }}
                      <button :disabled="!isEditingProfile" class="deleteButton d-flex">
                        <i class="la la-remove ml-2"></i>
                      </button>
                    </button>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </form>
      </div>
    </div>
    <zt-modal :active="profileModalActive" :title="$t('message.userActive.certSignModal.title')"
      @close="cancelEditInformation('isEditingProfile')">
      <template>
        <div class="p-10 text-center flex">
          <div class="pr-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" fill="none" viewBox="0 0 70 70">
              <circle cx="35" cy="35" r="34" fill="#fff" stroke="#FB8C00" stroke-width="2" />
              <path fill="#FB8C00" stroke="#FB8C00"
                d="M34.654 42.776c-.94 0-1.713-.772-1.713-1.713v-18.85c0-.941.772-1.713 1.713-1.713.94 0 1.713.772 1.713 1.713v18.85c0 .944-.753 1.713-1.713 1.713zM34.654 48.203c.94 0 1.713.772 1.713 1.713 0 .94-.772 1.712-1.713 1.712-.94 0-1.713-.772-1.713-1.712 0-.941.772-1.713 1.713-1.713z" />
            </svg>
          </div>
          <div>
            <div class="text-left">
              <p class="text-2xl text-zt-dark-500 mb-4">
                {{ $t('message.userActive.certSignModal.text_1') }}
              </p>
              <p class="text-lg text-zt-dark-500">
                {{ $t('message.userActive.certSignModal.text_2') }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <div class="zt-modal-footer flex justify-end p-4 bg-zt-dark-200">
          <zt-button class="ml-1" @click="cancelEditInformation('isEditingProfile')">{{
            $t('message.userActive.certSignModal.btnOk')
            }}</zt-button>
        </div>
      </template>
    </zt-modal>
    <div v-if="companyHasIntegrationProfile && profilesUser.length > 0" class="col-xl-12 col-lg-12 col-md-12 mb-4">
      <div class="card card-style">
        <div class="card-body">
          <div class="title_edit_container mb-2">
            <div>
              <div class="subtitle_useram">
                {{
                  $t('message.userActive.subtitle_employee_configuration_int_profiles')
                }}
              </div>
            </div>
            <transition name="fade" mode="out-in">
              <div v-if="isEditingIntegrationProfile" class="m-portlet__head-caption">
                <button @click="cancelEditInformation('isEditingIntegrationProfile')" class="btn btn-secondary mr-4">
                  {{ $t('message.ob_submit_swal_reject') }}
                </button>
                <button v-if="!loadingIntegrationProfiles" @click="saveUserProfiles(true)" class="btn btn-primary">
                  {{ $t('message.ei_personal_info_save_changes') }}
                </button>
                <button v-else class="btn btn-primary">
                  <div class="m-loader m-loader--light"></div>
                </button>
              </div>
            </transition>
          </div>
          <hr class="mt-4" />
          <div class="pl-0 col-xl-6 col-lg-6 col-md-6 col-sm-6 my-4 d-flex align-items-center">
            <div class="pl-3 col-xl-10 col-lg-10 col-md-10 col-sm-10 d-flex align-items-center edit-component">
              <multiselect v-model="integrationProfileSelected"
                :disabled="employeeState == 3 || !integrationProfilesCompany.length"
                :options="integrationProfilesCompany" :searchable="true" :close-on-select="true" :show-labels="false"
                label="nombre" :placeholder="$t('message.userActive.profile_management_int_title')">
                <template slot="noResult">
                  <span class="multiselect__single">{{
                    $t('message.userActive.error_int_profiles_not_found')
                    }}</span>
                </template>
                <template slot="option" slot-scope="props">
                  <span>{{ props.option.nombre }}</span>
                </template>
                <template slot="noOptions">
                  <span class="multiselect__single">{{
                    $t('message.actions.not_founded')
                    }}</span>
                </template>
              </multiselect>
            </div>
            <div v-if="integrationProfilesCompany.length > 0 && employeeState !== 3" @click="addIntegrationProfile()"
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 d-flex justify-content-start align-items-center">
              <div class="la la-plus-circle add-style"></div>
              <div class="button-add ml-1">
                {{ $t('message.userActive.add_employee_filter') }}
              </div>
            </div>
          </div>
          <transition v-if="integrationProfileSelectedList.length" name="slide" mode="out-in">
            <div v-if="employeeState !== 3">
              <div class="mr-4 mt-2 inline-block" v-for="(profile, index) in integrationProfileSelectedList"
                @click="removeIntegrationProfile(index)" :key="profile.nombre">
                <div class="btn btn-outline-brand btn-pill">
                  {{ profile.nombre }}
                  <button :disabled="!isEditingProfile" class="deleteButton d-flex">
                    <i class="la la-remove ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="ml-3 mr-3" id="alertErrorLicenses" ref="alert"></div>
    <div v-if="companyHasLicense" class="col-xl-12 col-lg-12 col-md-12 mb-4" id="licenses">
      <div class="card card-style">
        <form action @submit.prevent id>
          <div class="card-body">
            <div>
              <div class="title_edit_container mb-2">
                <div>
                  <div class="subtitle_useram">
                    {{ $t('message.userActive.title_license') }}
                  </div>
                </div>
                <transition name="fade" mode="out-in">
                  <div v-if="isEditingLicense" class="m-portlet__head-caption">
                    <button @click.prevent="cancelEditInformation('isEditingLicense')" class="btn btn-secondary mr-4">
                      {{ $t('message.ob_submit_swal_reject') }}
                    </button>
                    <button v-if="!loadingLicences" type="submit" @click.prevent="saveLicense"
                      href="#alertErrorLicenses" :disabled="errors.any()" class="btn btn-primary">
                      {{ $t('message.ei_personal_info_save_changes') }}
                    </button>
                    <button v-if="loadingLicences" type="submit" href="#alertErrorLicenses" class="btn btn-primary">
                      <div class="m-loader m-loader--light"></div>
                    </button>
                  </div>
                </transition>
              </div>
            </div>
            <div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <hr class="mt-4" />
                <div class="approve_license col-12">
                  <label @click="editInformation('isEditingLicense')"
                    class="m-checkbox m-checkbox--bold m-checkbox--state-success col3">
                    <input class="profiles-text" :value="tiene_perfil_aprobador" v-model="tiene_perfil_aprobador"
                      :disabled="employeeState == 3" id="tiene_perfil_aprobador" type="checkbox" />
                    {{ $t('message.userActive.tiene_perfil_aprobador') }}
                    <span></span>
                  </label>
                </div>
              </div>
              <div class="mt-3">
                <div class="d-flex">
                  <div class="second_subtitle_useram mb-3">
                    {{ $t('message.userActive.module_license') }}
                  </div>
                  <span @click="editInformation('isEditingLicense')"
                    class="m-switch m-switch--sm ml-4 d-flex align-items-center">
                    <label class="mb-0">
                      <input :disabled="employeeState == 3" :value="tiene_perfil_licencias"
                        v-model="tiene_perfil_licencias" type="checkbox" name />
                      <span class="mt-0 mb-0"></span>
                    </label>
                  </span>
                </div>
                <transition name="slide" mode="out-in">
                  <div v-if="tiene_perfil_licencias">
                    <div class="row col-12 mt-2">
                      <div class="col-12 input-label-container pl-0">
                        <div class="col-6 select-editable">
                          <label class="typo__label">{{
                            $t('message.userActive.numero_legajo_aprobador')
                            }}</label>
                          <multiselect id="ajaxUserLegajo" v-model="approverSelected"
                            @input="editInformation('isEditingLicense')" @search-change="debounceAsyncSearchLegajo"
                            :disabled="employeeState == 3 || niveles_aprobacion == 'Solo RRHH'
                              " label="nombre" name="nombre" :options="approversLicense" :searchable="true"
                            :internal-search="false" :clear-on-select="false" :close-on-select="true"
                            :show-labels="false" :loading="isLoading" :preserve-search="true"
                            :placeholder="$t('message.userActive.textFindLegajo')" v-validate.immediate="tiene_perfil_licencias &&
                                niveles_aprobacion !== 'Solo RRHH' &&
                                niveles_aprobacion !== null
                                ? 'required'
                                : ''
                              ">
                            <template slot="noResult">
                              <span class="multiselect__single">{{
                                $t('message.actions.not_founded')
                                }}</span>
                            </template>
                            <template slot="noOptions">
                              <span class="multiselect__single">{{
                                $t('message.actions.not_founded')
                                }}</span>
                            </template>
                          </multiselect>
                          <div class="m--font-danger" v-show="errors.has('nombre')">
                            <p class="error-style">
                              {{ $t('message.login_first_login_required_field') }}
                            </p>
                          </div>
                        </div>
                        <div class="col-6 select-editable">
                          <label class="typo__label">{{
                            $t('message.userActive.niveles_aprobacion')
                            }}</label>
                          <multiselect @input="
                            editInformation('isEditingLicense'),
                            changeLevel(niveles_aprobacion)
                            " v-model="niveles_aprobacion" :disabled="employeeState == 3" :options="licensesCompany"
                            :searchable="true" :close-on-select="true" :show-labels="false" id="nivelAprobacion"
                            name="nivelAprobacion" v-validate.immediate="tiene_perfil_licencias ? 'required' : ''
                              " :placeholder="$t('message.form_select')">
                            <template slot="noResult">
                              <span class="multiselect__single">{{
                                $t('message.actions.not_founded')
                                }}</span>
                            </template>
                            <template slot="noOptions">
                              <span class="multiselect__single">{{
                                $t('message.actions.not_founded')
                                }}</span>
                            </template>
                          </multiselect>
                          <div class="m--font-danger" v-show="errors.has('nivelAprobacion')">
                            <p class="error-style">
                              {{ $t('message.login_first_login_required_field') }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row col-12 mt-5">
                      <div class="col-12 input-label-container pl-0">
                        <div class="col-6 select-editable">
                          <label class="typo__label">{{
                            $t('message.userActive.id_politica')
                            }}</label>
                          <multiselect @input="editInformation('isEditingLicense')" v-model="id_politica" label="nombre"
                            :disabled="employeeState == 3 || disablePoliticasSelect" :options="policesCompany"
                            :searchable="true" :close-on-select="true" id="policiesCompany" name="policiesCompany"
                            :show-labels="false" :placeholder="$t('message.form_select')" v-validate.immediate="tiene_perfil_licencias ? 'required' : ''
                              ">
                            <template slot="noResult">
                              <span class="multiselect__single">{{
                                $t('message.actions.not_founded')
                                }}</span>
                            </template>
                            <template slot="noOptions">
                              <span class="multiselect__single">{{
                                $t('message.actions.not_founded')
                                }}</span>
                            </template>
                          </multiselect>
                          <div class="m--font-danger" v-show="errors.has('policiesCompany')">
                            <p class="error-style">
                              {{ $t('message.login_first_login_required_field') }}
                            </p>
                          </div>
                        </div>
                        <div class="col-6 group-inputs-label">
                          <input @input="validateAndLimitAntiguedadPrevia"
                            @keyup.delete="editInformation('isEditingLicense')" :disabled="employeeState == 3"
                            @keypress="editInformation('isEditingLicense')" v-model="antiguedad_previa"
                            class="input_styles" type="text" :required="antiquityLegTexting" maxlength="4" />
                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label class="label_styles">{{
                            $t('message.userActive.antiguedad_previa')
                            }}</label>
                        </div>
                      </div>
                    </div>

                    <div v-if="country == 'CL'" class="row col-12 mt-5">
                      <div class="col-12 input-label-container pl-0">
                        <div class="col-6 select-editable">
                          <label @click="
                            editInformation('isEditingLicense'),
                            changeStateLicencesProg()
                            " class="m-checkbox m-checkbox--bold m-checkbox--state-success col3">
                            <input class="profiles-text" :value="licencias.tiene_licencias_progresivas"
                              v-model="licencias.tiene_licencias_progresivas" :disabled="employeeState == 3"
                              id="tiene_licencias_progresivas" type="checkbox" />
                            {{ $t('message.userActive.tiene_licencias_progresivas') }}
                            <span></span>
                          </label>
                        </div>
                        <div class="col-6">
                          <datepicker @click="editInformation('isEditingLicense')"
                            @input="editInformation('isEditingLicense')" :language="es" :bootstrap-styling="true"
                            name="fecha_inicio_licencias_progresivas" id="fecha_inicio_licencias_progresivas"
                            format="dd/MM/yyyy" v-model="licencias.fecha_inicio_licencias_progresivas"
                            input-class="input-datepicker" :disabled="employeeState == 3 || !licencias.tiene_licencias_progresivas
                              "></datepicker>
                          <label class="label_styles_date" :class="[bornDateTexting ? 'elevateLabel' : '']"
                            style="left: 17px">
                            {{ $t('message.userActive.inicio_dias_progresivos') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import swal from 'sweetalert2'
import Folders from '../../../apiClient/Folders'
import Users from '../../../apiClient/User'
import UserManagement from '../../../apiClient/UserManagement'
import Multiselect from 'vue-multiselect'
import Alert from '@/components/generics/Alert.vue'
import Search from '../../../apiClient/Search'
import { findIndex, isEqual, debounce } from 'lodash'
import { mapGetters } from 'vuex'
import SichernIntegration from '@/apiClient/SichernIntegration'

export default {
  components: {
    Multiselect,
    Alert,
    Datepicker,
  },
  props: {
    employeeState: 0,
    country: '',
  },
  data() {
    return {
      es: es,
      DELIMITALLFILTERS: '*',
      RESERVEDWORK: '@all',
      TEXTALLFILTERS: `${this.$t('message.search_text_select_locacion')}`,
      TEXTNOSECTOR: `${this.$t('message.userActive.noSector')}`,
      TEXTNOLOCATION: `${this.$t('message.userActive.noLocation')}`,
      form: {
        profile: {
          managementState: '',
          employeeState: '',
          locationState: '',
          sectionState: '',
        },
      },
      licencias: {
        tiene_licencias_progresivas: false,
        fecha_inicio_licencias_progresivas: '',
      },
      fecha_contratacion: '',
      niveles_aprobacion: '',
      approversLicense: [],
      approverSelected: [],
      antiguedad_previa: '',
      id_politica: [],
      profilesCompany: [],
      profilesUser: [],
      employeeProfile: [],
      sectionCompany: [],
      locationCompany: [],
      sectionLocationEmployee: [],
      licensesCompany: [],
      policesCompany: [],
      isEditingIntegrationProfile: false,
      integrationProfilesCompany: [],
      integrationProfileSelected: null,
      integrationProfileSelectedList: [],
      integrationProfileCacheList: [],
      companyHasIntegrationProfile: false,
      profilesChangedList: [],
      profileRRHHCache: '',
      tiene_perfil_aprobador: false,
      companyFolders: [],
      foldersUser: [],
      folderSelected: '',
      folderMultiselect: true,
      companyId: null,
      isEditingProfile: false,
      isEditingLicense: false,
      isEditingFolders: false,
      numberLegTexting: false,
      antiquityLegTexting: false,
      tiene_perfil_licencias: false,
      companyHasLicense: false,
      companyId: 0,
      loadingProfiles: false,
      loadingIntegrationProfiles: false,
      loadingLicences: false,
      bornDateTexting: false,
      checkedDatePicker: false,
      infoUser: [],
      isLoading: false,
      time: null,
      auxFoldersCompany: [],
      hasRRHHxSector: false,
      otherRRHH: false,
      hasCertSign: false,
      profileModalActive: false,
      hasSichernPeopleIntegration: false,
      disablePoliticasSelect: false,
      debounceAsyncSearchLegajo: '',
    }
  },
  async created() {
    this.userClient = new Users()
    this.foldersClient = new Folders()
    this.userClient = new Users()
    this.userClientNew = new UserManagement()
    this.sichernIntegration = new SichernIntegration()
    this.ob = new Search()
    this.infoUser = JSON.parse(localStorage.getItem('user'))
    this.companyHasIntegrationProfile = this.isActionAllowed(106)
    await this.getProfileCompany(this.infoUser.empresa.id)
    this.getProfilesUser()
    this.getCompanySectionLocation()
    this.checkSichernPeopleIntegration()
    this.getFoldersUser(this.$route.params.id)
    this.getLicenses()
    this.getFoldersCompany()
    this.getUserInfo(this.$route.params.id)
    this.$store.dispatch('setActivateDate', false)
    this.debounceAsyncSearchLegajo = debounce(
      (value) => this.asyncSearchLegajo(value),
      500
    )
  },
  watch: {
    'licencias.fecha_inicio_licencias_progresivas': function (val) {
      if (this.licencias.fecha_inicio_licencias_progresivas !== '')
        this.bornDateTexting = true
      else this.bornDateTexting = false
    },
    antiguedad_previa: function (val) {
      if (this.antiguedad_previa !== '') this.antiquityLegTexting = true
      else this.antiquityLegTexting = false
    },
  },
  computed: {
    ...mapGetters(['isActionAllowed']),
  },
  methods: {
    hasProfileCertSign(profile) {
      return profile.includes('RRHH_CERT_SIGN')
    },
    getUserInfo(id) {
      this.userClient
        .getinfoEmployee(id)
        .then((res) => {
          if (res.status === 200) {
            let response = res.data
            if (response.fecha_nacimiento !== '' && response.fecha_nacimiento !== null)
              response.fecha_nacimiento = moment(
                response.fecha_nacimiento,
                'DD/MM/YYYY'
              ).format('llll')

            if (
              response.fecha_contratacion !== '' &&
              response.fecha_contratacion !== null
            ) {
              response.fecha_contratacion = moment(
                response.fecha_contratacion,
                'DD/MM/YYYY'
              ).format('llll')
            }

            let userList = {
              ...response,
              sector: response.sector ? response.sector : [],
              locacion: response.locacion ? response.locacion : [],
            }
            this.$store.dispatch('setUserList', userList)
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push('/404H/')
          }
        })
    },
    clearFilter() {
      this.sectionLocationEmployee = []
      this.foldersUser = []
      let folders = this.auxFoldersCompany
      folders.forEach((element, index) => {
        folders.splice(index, 0)
        this.companyFolders.push(element)
      })
      this.hasRRHHxSector = false
      this.otherRRHH = false
    },
    getFoldersCompany() {
      this.foldersClient
        .getFoldersAvailable(this.companyId)
        .then((res) => {
          if (res.status === 200) {
            this.auxFoldersCompany = res.data.results.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeStateLicencesProg() {
      if (this.licencias.tiene_licencias_progresivas) {
        this.licencias.fecha_inicio_licencias_progresivas = ''
      }
    },
    changeLevel(level) {
      if (level === 'Solo RRHH') {
        this.approverSelected = ''
      }
    },
    errorMessage(msg, type, title) {
      const ComponentClass = Vue.extend(Alert)
      const instance = new ComponentClass({
        propsData: { role: type, title: title, message: msg },
      }).$mount()
      this.$refs.alert.appendChild(instance.$el)
    },
    showErrors(errorsApi, userActive) {
      let title = ''
      let message = ''
      if (errorsApi.length > 0) {
        errorsApi.forEach((element, index) => {
          let arrData = element.split('|')
          arrData.forEach((value, key) => {
            if (key === 0) title = this.$t(userActive + value).toString()
            if (key === 1) message = value
          })
          this.errorMessage(message, 'danger', this.$t(title))
        })
      }
    },
    getCompanySectionLocation() {
      this.userClient
        .listSector()
        .then((res) => {
          if (res.status === 200) {
            this.sectionCompany.unshift(this.TEXTNOSECTOR)
            this.sectionCompany.unshift(this.TEXTALLFILTERS)
            res.data.results.data.slice(0).forEach((element) => {
              this.sectionCompany.push(element)
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })

      this.userClient
        .listLocacion()
        .then((res) => {
          if (res.status === 200) {
            this.locationCompany.unshift(this.TEXTNOLOCATION)
            this.locationCompany.unshift(this.TEXTALLFILTERS)
            res.data.results.data.slice(0).forEach((element) => {
              this.locationCompany.push(element)
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getProfilesUser() {
      this.profilesUser = []
      this.form.profile.managementState = ''
      this.userClientNew
        .getProfilesUser(this.$route.params.id)
        .then((res) => {
          if (res.status === 200) {
            this.profilesUser = res.data.perfiles
            this.profilesUser.forEach((element) => {
              if (element.idperfil === this.employeeProfile[0].id) {
                if (this.employeeProfile[0] !== null && this.employeeProfile[0] !== '') {
                  this.form.profile.employeeState = true
                } else {
                  this.form.profile.employeeState = false
                }
              }
              this.profilesCompany.forEach((profile) => {
                if (element.idperfil === profile.id) {
                  if (profile.nombre.includes('X_SECTOR')) {
                    this.hasRRHHxSector = true
                  } else {
                    this.hasRRHHxSector = false
                    this.otherRRHH = true
                  }
                  profile.nombre.includes('RRHH_CERT_SIGN')
                    ? (this.hasCertSign = true)
                    : (this.hasCertSign = false)
                  this.form.profile.managementState = profile
                  this.profileRRHHCache = profile
                }
              })
              if (this.companyHasIntegrationProfile) {
                this.integrationProfilesCompany.forEach((profile) => {
                  if (element.idperfil === profile.id) {
                    this.integrationProfileSelectedList = [
                      ...this.integrationProfileSelectedList,
                      ...[profile],
                    ]
                    const index = findIndex(this.integrationProfilesCompany, {
                      id: profile.id,
                    })
                    if (index !== -1) this.integrationProfilesCompany.splice(index, 1)
                  }
                })
              }
              if (
                this.form.profile.managementState !== null &&
                this.form.profile.managementState !== ''
              ) {
                this.$emit('rhChange', true)
              } else this.$emit('rhChange', false)
            })
            if (res.data.filtrosectores !== null)
              this.getFiltersUser(res.data.filtrosectores)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFiltersUser(filters) {
      this.sectionLocationEmployee = this.filtersDelimiters(filters, '*')
    },
    filtersDelimiters(filters, findBy) {
      let filtersDelimiters = []
      filters.forEach((element) => {
        const arrayItem = []
        let section = ''
        let location = ''
        if (findBy === '*') {
          element[1] == this.DELIMITALLFILTERS
            ? (section = this.TEXTALLFILTERS)
            : (section = element[1])
          element[0] == this.DELIMITALLFILTERS
            ? (location = this.TEXTALLFILTERS)
            : (location = element[0])
        } else {
          element[1] == this.TEXTALLFILTERS
            ? (section = this.RESERVEDWORK)
            : (section = element[1])
          element[0] == this.TEXTALLFILTERS
            ? (location = this.RESERVEDWORK)
            : (location = element[0])
        }
        arrayItem.push(location, section)
        filtersDelimiters.push(arrayItem)
      })
      return filtersDelimiters
    },
    validateRepeatSectionLocation(location, section) {
      let validateRepeatSectionLocation = false
      this.sectionLocationEmployee.forEach((element) => {
        if (element[0] === location && element[1] === section) {
          this.isEditingProfile = false
          validateRepeatSectionLocation = true
          swal({
            type: 'error',
            title: `${this.$t('message.userActive.error_location_seccion_added')}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t('message.billboard_form_post_button_confirm')}`,
          })
        }
      })
      return validateRepeatSectionLocation
    },
    addSectionLocation() {
      if (
        this.form.profile.sectionState !== '' &&
        this.form.profile.locationState !== ''
      ) {
        this.isEditingProfile = true
        let tmp = []
        let validate = this.validateRepeatSectionLocation(
          this.form.profile.locationState,
          this.form.profile.sectionState
        )
        if (!validate) {
          if (
            this.form.profile.locationState === this.TEXTNOLOCATION &&
            this.form.profile.sectionState === this.TEXTNOSECTOR
          ) {
            this.isEditingProfile = false
            swal({
              type: 'error',
              title: `${this.$t('message.userActive.empty_location_and_sector_text')}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t(
                'message.billboard_form_post_button_confirm'
              )}`,
            })
          } else {
            tmp.push(this.form.profile.locationState, this.form.profile.sectionState)
            this.sectionLocationEmployee.push(tmp)
          }
        }
      } else {
        swal({
          type: 'error',
          title: `${this.$t('message.userActive.empty_location_and_sector_text')}`,
          showConfirmButton: true,
          confirmButtonText: `${this.$t('message.billboard_form_post_button_confirm')}`,
        })
      }
      this.blankFiltersConfiguration()
    },
    blankFiltersConfiguration() {
      this.form.profile.sectionState = ''
      this.form.profile.locationState = ''
    },
    deleteSectionLocation(location, section) {
      this.isEditingProfile = true
      this.sectionLocationEmployee.forEach((element, index) => {
        if (element[0] === location && element[1] === section) {
          this.sectionLocationEmployee.splice(index, 1)
        }
      })
    },
    saveUserProfiles(integrationProfiles = false) {
      if (
        this.form.profile.managementState !== null &&
        this.form.profile.managementState !== ''
      ) {
        if (this.form.profile.managementState.nombre.includes('RRHH_CERT_SIGN')) {
          this.profileModalActive = true
          return
        }
      }

      let profiles = []

      if (integrationProfiles) {
        this.loadingIntegrationProfiles = true
        profiles = this.profilesChangedList
          .filter((item) => item.id_perfil_tipo === '4')
          .map((profile) => profile.id)
      } else {
        this.loadingProfiles = true
        profiles = this.profilesChangedList
          .filter((item) => item.id_perfil_tipo !== '4')
          .map((profile) => profile.id)
      }

      let userprofiles = ''

      if (this.form.profile.managementState !== '' || this.form.profile.employeeState) {
        if (profiles.length === 1) {
          userprofiles = profiles[0].toString()
        } else {
          userprofiles = profiles.join(',')
        }
        this.userClientNew
          .putProfilesUser(this.$route.params.id, userprofiles)
          .then((res) => {
            if (res.status === 200) {
              this.profilesChangedList = []
              this.profileRRHHCache = ''
              let filters = []
              if (this.sectionLocationEmployee.length !== 0) {
                filters = this.filtersDelimiters(
                  this.sectionLocationEmployee,
                  this.TEXTALLFILTERS
                )
              } else {
                filters = ''
              }
              this.userClientNew
                .putFiltersUser(this.$route.params.id, filters)
                .then((res) => {
                  if (res.status === 200) {
                    this.saveFolders()
                  }
                })
                .catch((error) => {
                  swal({
                    type: 'error',
                    title: `${this.$t('message.actions.error')}`,
                    showConfirmButton: true,
                    confirmButtonText: `${this.$t(
                      'message.billboard_form_post_button_confirm'
                    )}`,
                  }).then(() => {
                    this.getProfilesUser()
                    this.getFoldersUser(this.$route.params.id)
                    this.loadingProfiles = false
                    this.loadingIntegrationProfiles = false
                    this.profilesChangedList = []
                  })
                })
            }
          })
          .catch((error) => {
            this.isEditingIntegrationProfile = false
            swal({
              type: 'error',
              title: `${this.$t('message.actions.error')}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t(
                'message.billboard_form_post_button_confirm'
              )}`,
            }).then(() => {
              this.getProfilesUser()
              this.getFoldersUser(this.$route.params.id)
              this.loadingProfiles = false
              this.loadingIntegrationProfiles = false
              this.profilesChangedList = []
            })
          })
      } else {
        this.isEditingIntegrationProfile = false
        swal({
          type: 'error',
          title: `${this.$t(
            'message.userActive.change_employee_configuration_profiles_error'
          )}`,
          showConfirmButton: true,
          confirmButtonText: `${this.$t('message.billboard_form_post_button_confirm')}`,
        }).then(() => {
          this.getProfilesUser()
          this.getFoldersUser(this.$route.params.id)
          this.loadingProfiles = false
          this.loadingIntegrationProfiles = false
          this.profilesChangedList = []
        })
      }
    },
    editInformation(event) {
      if (this.employeeState != 3) {
        switch (event) {
          case 'isEditingLicense':
            this.isEditingLicense = true
            break
          case 'isEditingProfile':
            this.isEditingProfile = true
            break
          case 'isEditingFolders':
            this.isEditingFolders = true
            break
          default:
            console.log('bad request')
        }
      }
    },
    cancelEditInformation(event) {
      switch (event) {
        case 'isEditingLicense':
          {
            this.getLicenses()
            this.isEditingLicense = false
          }
          break
        case 'isEditingFolders':
          {
            this.getFoldersUser(this.$route.params.id)
            this.isEditingFolders = false
          }
          break
        case 'isEditingProfile':
        case 'isEditingIntegrationProfile':
          {
            this.getCompanySectionLocation()
            this.getProfilesUser()
            this.getFoldersUser(this.$route.params.id)
            this.profileModalActive = false
            this.isEditingProfile = false
            if (this.companyHasIntegrationProfile) {
              this.isEditingIntegrationProfile = false
              this.integrationProfilesCompany = [...this.integrationProfileCacheList]
              this.integrationProfileSelectedList = []
            }
            this.profilesChangedList = []
          }
          break
        default:
          console.log('bad request')
      }
    },
    async getLicenses() {
      await this.getPolicies()
      await this.getUserLicences()
    },
    async checkSichernPeopleIntegration() {
      const type = 'VP_ABSENCES_HOLIDAYS'
      const { data } = (
        await this.sichernIntegration.checkIntegrationSichernPeopleByType(type)
      ).data
      this.hasSichernPeopleIntegration = data.enabled
    },
    async getPolicies() {
      await this.userClientNew
        .getPolicies()
        .then((res) => {
          if (res.status === 200) {
            this.policesCompany = res.data.results.data
            this.licensesCompany = [
              `${this.$t('message.userActive.only_rh')}`,
              `${this.$t('message.userActive.level_one')}`,
              `${this.$t('message.userActive.level_two')}`,
            ]
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getUserLicences() {
      await this.userClientNew
        .getUserLicences(this.$route.params.id)
        .then((res) => {
          if (res.status === 200) {
            let response = res.data
            this.tiene_perfil_licencias = response.tiene_perfil_licencias
            this.tiene_perfil_aprobador = response.es_aprobador
            this.licencias.tiene_licencias_progresivas = response.licencias_progresivas
            if (
              response.fecha_inicio_licencias_progresivas !== '' &&
              response.fecha_inicio_licencias_progresivas !== null
            ) {
              this.licencias.fecha_inicio_licencias_progresivas = moment(
                response.fecha_inicio_licencias_progresivas,
                'DD/MM/YYYY'
              ).format('llll')
            }
            if (response.numero_legajo_aprobador !== null) {
              this.asyncSearchLegajo(response.numero_legajo_aprobador.toString(), true)
            }
            if (response.antiguedad_previa !== null)
              this.antiguedad_previa = response.antiguedad_previa
            let idPol = response.id_politica
            this.policesCompany.forEach((element) => {
              if (this.hasSichernPeopleIntegration && element.is_default === 't') {
                this.disablePoliticasSelect = true
                this.id_politica = element
              }
              if (idPol == element.id) this.id_politica = element
            })
            let levelLicense = response.niveles_aprobacion
            this.licensesCompany.forEach((element, index) => {
              if (index === levelLicense) this.niveles_aprobacion = element
            })
            this.companyHasLicense = true
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.status === 404) {
            this.companyHasLicense = false
          }
        })
    },
    saveLicense() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          let levelLicense = 0
          let tiene_perfil_licencias = 0
          let tiene_perfil_aprobador = 0
          let id = null
          let numero_legajo = ''
          let idUserAprobador = ''
          let tiene_licencias_progresivas = 0
          let fecha_inicio_licencias_progresivas = ''
          this.loadingLicences = true

          if (
            this.licencias.fecha_inicio_licencias_progresivas !== '' &&
            this.licencias.fecha_inicio_licencias_progresivas !== null
          ) {
            fecha_inicio_licencias_progresivas = moment(
              this.licencias.fecha_inicio_licencias_progresivas
            ).format('DD/MM/YYYY')
          }

          this.licencias.tiene_licencias_progresivas
            ? (tiene_licencias_progresivas = 1)
            : (tiene_licencias_progresivas = 0)

          this.licensesCompany.forEach((element, index) => {
            if (this.niveles_aprobacion === element) levelLicense = index
          })
          if (this.tiene_perfil_aprobador) tiene_perfil_aprobador = 1
          else tiene_perfil_aprobador = 0
          if (this.id_politica !== null) id = this.id_politica.id
          const approverSelectedData = JSON.parse(JSON.stringify(this.approverSelected))
          if (
            Object.entries(approverSelectedData).length !== 0 ||
            approverSelectedData.length !== 0
          ) {
            numero_legajo = approverSelectedData.numero_legajo
            idUserAprobador = approverSelectedData.id
          }
          this.fecha_contratacion = this.$store.getters.getUserList.fecha_contratacion
          if (this.tiene_perfil_licencias) {
            if (this.fecha_contratacion !== null && this.fecha_contratacion !== '') {
              tiene_perfil_licencias = 1
              this.userClientNew
                .putUserLicences(
                  this.$route.params.id,
                  tiene_perfil_licencias,
                  tiene_perfil_aprobador,
                  levelLicense,
                  numero_legajo,
                  id,
                  this.antiguedad_previa,
                  tiene_licencias_progresivas,
                  fecha_inicio_licencias_progresivas,
                  idUserAprobador
                )
                .then((res) => {
                  if (res.status === 200) {
                    this.loadingLicences = false
                    swal({
                      type: 'success',
                      title: `${this.$t('message.msj_success_modify_user')}`,
                      showConfirmButton: true,
                      confirmButtonText: `${this.$t(
                        'message.billboard_form_post_button_confirm'
                      )}`,
                    }).then(() => {
                      this.approversLicense = []
                      this.getLicenses()
                      this.isEditingLicense = false
                    })
                  }
                })
                .catch((error) => {
                  this.loadingLicences = false
                  if (error.response.status === 409) {
                    let message = 'message.userActive.'
                    this.showErrors(error.response.data.validations, message)
                  }
                  if (error.response.status === 400) {
                    let message = 'message.userActive.'
                    this.showErrors(error.response.data.validations, message)
                  }
                  document.getElementById('licenses').scrollIntoView()
                })
            } else {
              swal({
                type: 'warning',
                title: `${this.$t('message.msj_warning_edit')}`,
                text: `${this.$t('message.msj_warning_edit_date')}`,
                showConfirmButton: true,
                confirmButtonText: `${this.$t(
                  'message.billboard_form_post_button_confirm'
                )}`,
              }).then(() => {
                this.loadingLicences = false
                this.isEditingLicense = false
                this.$store.dispatch('setActivateDate', true)
              })
            }
          } else {
            tiene_perfil_licencias = 0
            this.userClientNew
              .putUserLicences(
                this.$route.params.id,
                tiene_perfil_licencias,
                tiene_perfil_aprobador
              )
              .then((res) => {
                if (res.status === 200) {
                  this.loadingLicences = false
                  swal({
                    type: 'success',
                    title: `${this.$t('message.msj_success_modify_user')}`,
                    showConfirmButton: true,
                    confirmButtonText: `${this.$t(
                      'message.billboard_form_post_button_confirm'
                    )}`,
                  }).then(() => {
                    this.approversLicense = []
                    this.getLicenses()
                    this.isEditingLicense = false
                  })
                }
              })
              .catch((error) => {
                this.loadingLicences = false
                if (error.response.status === 409) {
                  let message = 'message.userActive.'
                  this.showErrors(error.response.data.validations, message)
                }
                if (error.response.status === 400) {
                  let message = 'message.userActive.'
                  this.showErrors(error.response.data.validations, message)
                }
                document.getElementById('licenses').scrollIntoView()
              })
          }
        }
      })
    },
    addFolder() {
      {
        {
          this.companyFolders
        }
      }
      if (this.companyFolders.length !== 0) {
        let duplicated = false
        this.isEditingProfile = true
        let selected = this.folderSelected
        this.companyFolders.forEach((element, index) => {
          if (element.carpeta_id === selected.carpeta_id) {
            this.companyFolders.splice(index, 1)
            this.foldersUser.map((folderInUser) => {
              if (folderInUser.carpeta_id === selected.carpeta_id) {
                duplicated = true
              }
            })
            if (!duplicated) {
              this.foldersUser.push(selected)
            }
          }
        })
      }
      this.folderSelected = ''
    },
    // remove a folder in the ArrayFolders
    removeItem(index) {
      this.isEditingProfile = true
      this.companyFolders.push(this.foldersUser[index])
      this.foldersUser.splice(index, 1)
    },
    async getProfileCompany(id) {
      await this.userClientNew
        .getProfileCompany(id)
        .then((res) => {
          if (res.status === 200) {
            this.profilesCompany = res.data.filter((item) => item.id_perfil_tipo !== '4')
            // console.log(this.profilesCompany);
            let index = 0
            this.profilesCompany.forEach((element, index) => {
              if (element.id_perfil_tipo === '1') {
                this.employeeProfile.push(element)
                this.profilesCompany.splice(index, 1)
              }
              index++
            })

            if (this.companyHasIntegrationProfile) {
              this.integrationProfilesCompany = res.data.filter(
                (profile) => profile.id_perfil_tipo === '4'
              )
              this.integrationProfileCacheList = [...this.integrationProfilesCompany]
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFoldersUser(userId) {
      // console.log("entro en getFoldersUser");
      this.foldersUser = []
      this.companyFolders = []
      this.foldersClient
        .getFoldersAvailable(this.companyId)
        .then((res) => {
          if (res.status === 200) {
            this.companyFolders = res.data.results.data
            this.foldersClient
              .getFoldersUser(userId)
              .then((res) => {
                if (res.status === 200) {
                  if (res.data.length > 0) {
                    let userfolderaux = []
                    for (let i = 0; i < res.data.length; i++) {
                      const params = {
                        carpeta_id: res.data[i].idcarpeta,
                        carpeta_nombre: res.data[i].name,
                      }
                      this.companyFolders.forEach((element, index) => {
                        if (element.carpeta_nombre === res.data[i].name) {
                          this.companyFolders.splice(index, 1)
                        }
                      })
                      userfolderaux.push(params)
                    }
                    this.foldersUser = this.getUnique(userfolderaux)
                  }
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getUnique(array) {
      let uniqueArray = []
      // Loop through array values
      for (let i = 0; i < array.length; i++) {
        if (uniqueArray.indexOf(array[i]) === -1) {
          uniqueArray.push(array[i])
        }
      }
      return uniqueArray
    },
    saveFolders() {
      let foldersAux = []
      this.foldersUser.forEach((element, index) => {
        foldersAux.push(element.carpeta_id)
      })
      const params = {
        idusuario: this.$route.params.id,
        idcarpeta: foldersAux.join(','),
      }
      this.foldersClient
        .deleteFoldersUser(this.$route.params.id)
        .then((res) => {
          if (res.status === 200) {
            if (this.foldersUser.length > 0) {
              this.foldersClient.addFoldersUser(params).then(() => {
                swal({
                  type: 'success',
                  title: `${this.$t(
                    'message.userActive.change_employee_configuration_profiles'
                  )}`,
                  showConfirmButton: true,
                  confirmButtonText: `${this.$t(
                    'message.billboard_form_post_button_confirm'
                  )}`,
                }).then(() => {
                  this.loadingProfiles = false
                  this.loadingIntegrationProfiles = false
                  this.getProfilesUser()
                  this.getFoldersUser(this.$route.params.id)
                  this.isEditingProfile = false
                  this.isEditingIntegrationProfile = false
                })
              })
            } else {
              swal({
                type: 'success',
                title: `${this.$t(
                  'message.userActive.change_employee_configuration_profiles'
                )}`,
                showConfirmButton: true,
                confirmButtonText: `${this.$t(
                  'message.billboard_form_post_button_confirm'
                )}`,
              }).then(() => {
                this.loadingProfiles = false
                this.loadingIntegrationProfiles = false
                this.getProfilesUser()
                this.getFoldersUser(this.$route.params.id)
                this.isEditingProfile = false
                this.isEditingIntegrationProfile = false
              })
            }
          }
        })
        .catch((error) => {
          this.loadingProfiles = false
          this.loadingIntegrationProfiles = false
          console.log(error)
        })
    },
    async asyncSearchLegajo(q, flag = false) {
      this.cleanLegajo()
      let qrySearchInit =
        '{"where":[{"fields":[{"operator":"in","alias":"numero_legajo","value":["' +
        q +
        '"]}]}]}'
      this.isLoading = true
      try {
        if (q.length >= 1) {
          const { data } = await this.ob.SearchUsuario('usuario', qrySearchInit)
          this.isLoading = false
          if (!data.results.data[0]) {
            return
          }
          let nombreApellido = `${data.results.data[0].numero_legajo} - ${data.results.data[0].nombre} ${data.results.data[0].apellido} `
          const tmp = {
            nombre: nombreApellido,
            numero_legajo: data.results.data[0].numero_legajo,
            id: data.results.data[0].id,
          }
          if (flag === true) {
            this.approverSelected = tmp
          } else {
            this.approversLicense.push(tmp)
          }
        } else this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.cleanLegajo()
        console.log(error)
      }
    },
    cleanLegajo() {
      this.approversLicense = []
    },
    addIntegrationProfile() {
      if (!this.integrationProfileSelected) return
      const index = findIndex(this.integrationProfilesCompany, {
        id: this.integrationProfileSelected.id,
      })
      if (index !== -1) {
        this.profileTo(this.integrationProfileSelected)
        this.integrationProfileSelectedList.push(this.integrationProfileSelected)
        this.integrationProfilesCompany.splice(index, 1)
        this.integrationProfileSelected = null
        this.isEditingIntegrationProfile = true
      }
    },
    removeIntegrationProfile(index) {
      this.profileTo(this.integrationProfileSelectedList[index])
      this.integrationProfilesCompany.push(this.integrationProfileSelectedList[index])
      this.integrationProfileSelectedList.splice(index, 1)
      this.isEditingIntegrationProfile = true
    },
    profileTo(profile) {
      const index = findIndex(this.profilesChangedList, { id: profile.id })
      if (index === -1) this.profilesChangedList.push(profile)
      else this.profilesChangedList.splice(index, 1)
    },
    addEmployeeProfile() {
      this.profileTo(this.employeeProfile[0])
    },
    async addRRHHProfile() {
      this.editInformation('isEditingProfile')
      if (this.profileRRHHCache) this.profileTo(this.profileRRHHCache)
      this.profileTo(this.form.profile.managementState)
      this.profileRRHHCache = this.form.profile.managementState
    },
    clearRRHHProfile() {
      this.profileTo(this.form.profile.managementState)
      this.form.profile.managementState = ''
      this.profileRRHHCache = ''
    },
    validateAndLimitAntiguedadPrevia(event) {
      const inputValue = event.target.value
      const sanitizedValue = inputValue.replace(/[^0-9]/g, '')
      if (sanitizedValue !== '') {
        const numericValue = parseInt(sanitizedValue, 10)
        this.antiguedad_previa = Math.min(Math.max(numericValue, 1), 1200)
      } else {
        this.antiguedad_previa = ''
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import './public/assets/scss/components/_configurationemployee.scss';
</style>
